import styled from 'styled-components';

import {i18n} from '@yourcoach/i18n';

import NoConferencesSvg from '../../../assets/icons/empty-state/no_conferences.svg';
import {alert} from '../../../components/alert';
import {Text} from '../../../uikit/Text';
import {View} from '../../../uikit/View';
import {logger} from '../../../utils/logger';

type Config = {
  onBook: () => void;
  onCancel: () => void;
};

export const showBookNextConferenceAlert = ({onBook, onCancel}: Config) => {
  logger.event('book_next_session_view');

  return alert.show({
    buttons: [
      {
        label: i18n.t('shared:later'),
        onClick: () => {
          logger.event('book_next_session_skip_tap');

          onCancel();
        },
      },
      {
        label: i18n.t('shared:schedule_session.live'),
        onClick: () => {
          onBook();

          logger.event('book_next_session_tap');
        },
        scheme: 'secondary',
      },
    ],
    icon: NoConferencesSvg,
    iconColor: 'icon.secondary',
    iconSize: 160,
    isDismissible: true,
    onDismiss() {
      logger.event('book_next_session_skip_tap');

      onCancel();
    },
    renderMessage,
    title: i18n.t('shared:insightful_session'),
  });
};

const MessageContainer = styled(View)`
  flex-direction: column;
  align-items: center;
`;

const MessageLine = styled(Text)`
  text-align: center;
`;

const renderMessage = () => (
  <MessageContainer>
    <MessageLine>{i18n.t('shared:you_one_step_closer_to_goals')}</MessageLine>
    <MessageLine>{i18n.t('shared:book_your_next_session')}</MessageLine>
  </MessageContainer>
);
